import React from 'react';
import { detectCarrier } from '../../lib/trackingCarrier';
import styles from './TrackingCell.module.scss';

interface TrackingCellProps {
  trackingNumber: string | null | undefined;
}

export default function TrackingCell({ trackingNumber }: TrackingCellProps) {
  if (!trackingNumber) {
    return <>{'\u2014'}</>;
  }
  const match = detectCarrier(trackingNumber);
  if (!match) {
    return <>{trackingNumber}</>;
  }
  return (
    <a href={match.url} target="_blank" rel="noopener noreferrer" className={styles.trackingLink}>
      <span className={styles.trackingNumber}>{trackingNumber}</span>
      <span className={styles.trackingCarrier}>{match.carrier}</span>
      <svg
        className={styles.trackingExternalIcon}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
      >
        <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" />
        <polyline points="15 3 21 3 21 9" />
        <line x1="10" y1="14" x2="21" y2="3" />
      </svg>
    </a>
  );
}
